export function utilBadgeClass(util: number) {
  if (util >= 70) return 'bg-emerald-100 text-emerald-800'
  if (util >= 50) return 'bg-amber-100 text-amber-800'
  return 'bg-red-100 text-red-800'
}
